module.exports = __webpack_public_path__ + "images/c054bd2523f6aa1f3dc6612921ec18fc.png";